import { observer } from "mobx-react-lite";

import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { SubmissionForm } from "@ui-components/form/submission-form/SubmissionForm.tsx";

import { ClinicalReminderFields } from "./ClinicalReminderFields.tsx";
import { ClinicalReminderPreferenceFormValues } from "./ClinicalReminderPreferenceForm.types.ts";

export const ClinicalReminderPreferenceForm: React.FC = observer(() => {
  const { clinical, core, notification } = useStores();

  const initialValues: ClinicalReminderPreferenceFormValues = {
    allowReminderFreeText:
      !!clinical.clinicalActivitiesPreference?.allowReminderFreeText,
    useReminderMinRange:
      !!clinical.clinicalActivitiesPreference?.useReminderMinRange,
    reminderMinWeekRange:
      clinical.clinicalActivitiesPreference?.reminderMinWeekRange ?? 0
  };

  const onSubmit = async (values: ClinicalReminderPreferenceFormValues) => {
    const clinicalActivityPreference =
      clinical.clinicalActivitiesPreference?.dto;
    if (clinicalActivityPreference) {
      await clinical.patchClinicalActivitiesPreference({
        id: clinicalActivityPreference.id,
        allowReminderFreeText: !!values.allowReminderFreeText,
        useReminderMinRange: values.useReminderMinRange,
        reminderMinWeekRange: values.reminderMinWeekRange,
        eTag: clinicalActivityPreference.eTag
      });
    }
  };

  return (
    <SubmissionForm<ClinicalReminderPreferenceFormValues>
      formName="clinical-reminders-preferences"
      onSubmitSucceeded={() => {
        notification.success("Clinical reminders preference has been updated.");
      }}
      readOnly={!core.hasPermissions(Permission.OrgUnitSettingWrite)}
      autoFocus={false}
      onSubmit={onSubmit}
      initialValues={initialValues}
      hideButtons
    >
      {() => <ClinicalReminderFields />}
    </SubmissionForm>
  );
});
